export enum ReturnReasonCode {
    SpecialExpressReturn = "SpecialExpressReturn",
    ServEngrAndInternReturn = "ServEngrAndInternReturn",
    CustomerServiceReturn = "CustomerServiceReturn",
    SpecialNumber1DealerReturn = "SpecialNumber1DealerReturn",
    SpecialNumber2DealerReturn = "SpecialNumber2DealerReturn",
    TransitionReturn = "TransitionReturn",
    TerminationReturn = "TerminationReturn",
    AnnualReturnProgram = "AnnualReturnProgram",
    DiscrepancyTestProgram = "DiscrepancyTestProgram",
    ExpressReturnProgram = "ExpressReturnProgram",
    LiteratureReturnProgram = "LiteratureReturnProgram",
    PromatchExpressReturn = "PromatchExpressReturn",
    PromatchAnnualReturn = "PromatchAnnualReturn",
}
